/**
 * Shared between the Turnstile widget (components/auth/captcha.tsx) and the auth server actions,
 * which must agree on the field the solved token travels in and on what a visitor is told when the
 * challenge cannot be satisfied.
 */

export const CAPTCHA_TOKEN_FIELD = 'captchaToken';

export const CAPTCHA_FAILED_MESSAGE =
  "We couldn't verify that you're human. Please reload the page and try again.";
